<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="850px"
    :title="titleName + '标题表单'"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
  >
    <el-form :model="form" :rules="formRules" ref="form">
      <el-form-item label="状态" :label-width="formLabelWidth" prop="status">
        <el-select
          class="search-select"
          v-model="statuName"
          placeholder="请选择状态"
          @change="changeRole"
        >
          <el-option
            v-for="(item, index) in rolesList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="标题" :label-width="formLabelWidth" prop="title">
        <el-input v-model="form.title" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="图标" :label-width="formLabelWidth" prop="icon">
        <el-upload
          class="avatar-uploader"
          :action="actionUrl"
          :show-file-list="false"
          :http-request="httpRequest"
        >
          <img v-if="form.icon" :src="form.icon" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveBtn">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addHelpApi, setHelpApi } from '@/api/newsApi.js';
import { pictureUpload } from '@/api/bannerApi.js';
export default {
  name: 'titleForm',
  data() {
    return {
      formLabelWidth: '80px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      form: {
        title: '',
        status: '',
        icon: '',
      },
      actionUrl: '',
      statuName: '',
      titleName: '新增',
      rolesList: [
        { label: '编辑中', value: 1 },
        { label: '已发布', value: 2 },
        { label: '已删除', value: 3 },
      ],
      editor: undefined, // 编辑器
      formRules: {
        title: [
          {
            required: true,
            message: '标题不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        status: [
          {
            required: true,
            message: '请选择状态',
            trigger: ['blur', 'change'],
          },
        ],
        icon: [
          {
            required: true,
            message: '请上传图标',
            trigger: ['blur', 'change'],
          },
        ],
      },
      fileList: [
        {
          name: 'food.jpeg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
        },
      ],
    };
  },
  methods: {
    // 保存
    saveBtn() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.titleName === '新增' ? this.add() : this.edit();
        this.$message.success(this.titleName + '成功!');
        this.dialogFormVisible = false;
        // 清空表单
        this.$refs['form'].resetFields();
        // 重新请求数据
        this.$emit('fetchData');
      });
    },

    // 新增
    async add() {
      try {
        let data =
          'icon=' +
          this.form.icon +
          '&status=' +
          this.form.status +
          '&title=' +
          this.form.title;
        let res = await addHelpApi(data);
        if (res.code !== 200) return;
      } catch (e) {
        window.console.log(e);
      }
    },

    // 点击状态下拉数据
    changeRole(val) {
      this.form.status = val;
    },

    // 编辑
    async edit() {
      try {
        let data =
          'icon=' +
          this.form.icon +
          '&title=' +
          this.form.title +
          '&status=' +
          this.form.status +
          '&helpId=' +
          this.form.helpId;
        let res = await setHelpApi(data);
        if (res.code !== 200) return;
      } catch (e) {
        window.console.log(e);
      }
    },

    // 上传图片
    httpRequest(options) {
      try {
        let file = options.file;
        let reader = new FileReader();
        if (file) {
          reader.readAsDataURL(file);
        }
        reader.onload = async () => {
          let base64Str = reader.result;
          await pictureUpload({
            base64string: base64Str,
            fileName: file.name,
          })
            .then((res) => {
              this.form.icon = res.data.absoluteFileUrl;
            })
            .catch((err) => {
              window.console.log(err);
              this.$message.error('上传失败，请刷新重试！');
            });
        };
      } catch (e) {
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
